'use strict';

exports.__esModule = true;
exports.TreeMapCanvasDefaultProps = exports.TreeMapHtmlDefaultProps = exports.TreeMapPlaceholdersDefaultProps = exports.TreeMapDefaultProps = exports.TreeMapHtmlCanvasPropTypes = exports.TreeMapHtmlPropTypes = exports.TreeMapPlaceholdersPropTypes = exports.TreeMapPropTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
                                                                                                                                                                                                                                                                   */


var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _noop = require('../../../lib/noop');

var _noop2 = _interopRequireDefault(_noop);

var _props = require('../../../props');

var _TreeMapNode = require('./TreeMapNode');

var _TreeMapNode2 = _interopRequireDefault(_TreeMapNode);

var _TreeMapHtmlNode = require('./TreeMapHtmlNode');

var _TreeMapHtmlNode2 = _interopRequireDefault(_TreeMapHtmlNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*—————————————————————————————————————————————————————————————————————————————

  Prop types

—————————————————————————————————————————————————————————————————————————————*/

var commonPropTypes = {
    // data
    // `root` managed by `withHierarchy()` HOC
    identity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,

    // dimensions managed by `withDimensions()` HOC

    // styling
    // theme managed by `withTheme()` HOC
    // colors managed by `withColors()` HOC

    leavesOnly: _propTypes2.default.bool.isRequired,
    tile: _props.treeMapTilePropType.isRequired,
    innerPadding: _propTypes2.default.number.isRequired,
    outerPadding: _propTypes2.default.number.isRequired,

    // labels
    enableLabel: _propTypes2.default.bool.isRequired,
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
    labelFormat: _propTypes2.default.string,
    labelSkipSize: _propTypes2.default.number.isRequired,
    orientLabel: _propTypes2.default.bool.isRequired,

    // border
    borderWidth: _propTypes2.default.number.isRequired,
    borderColor: _propTypes2.default.any.isRequired,

    // interactivity
    isInteractive: _propTypes2.default.bool.isRequired,
    onClick: _propTypes2.default.func.isRequired
};

var TreeMapPropTypes = exports.TreeMapPropTypes = _extends({}, commonPropTypes, {
    nodeComponent: _propTypes2.default.func.isRequired
}, _props.defsPropTypes);

var TreeMapPlaceholdersPropTypes = exports.TreeMapPlaceholdersPropTypes = TreeMapPropTypes;

var TreeMapHtmlPropTypes = exports.TreeMapHtmlPropTypes = _extends({}, commonPropTypes, {
    nodeComponent: _propTypes2.default.func.isRequired
});

var TreeMapHtmlCanvasPropTypes = exports.TreeMapHtmlCanvasPropTypes = _extends({}, commonPropTypes, {
    pixelRatio: _propTypes2.default.number.isRequired

    /*—————————————————————————————————————————————————————————————————————————————
    
      Default props
    
    —————————————————————————————————————————————————————————————————————————————*/

});var commonDefaultProps = {
    // data
    identity: 'id',

    tile: 'squarify',
    leavesOnly: false,

    // labels
    enableLabel: true,
    label: 'id',
    labelSkipSize: 0,
    labelTextColor: 'inherit:darker(1)',
    orientLabel: true,

    innerPadding: 0,
    outerPadding: 0,

    borderWidth: 0,
    borderColor: 'inherit',

    // interactivity
    isInteractive: true,
    onClick: _noop2.default
};

var TreeMapDefaultProps = exports.TreeMapDefaultProps = _extends({}, commonDefaultProps, {
    nodeComponent: _TreeMapNode2.default,
    defs: [],
    fill: []
});

var TreeMapPlaceholdersDefaultProps = exports.TreeMapPlaceholdersDefaultProps = TreeMapDefaultProps;

var TreeMapHtmlDefaultProps = exports.TreeMapHtmlDefaultProps = _extends({}, commonDefaultProps, {
    nodeComponent: _TreeMapHtmlNode2.default
});

var TreeMapCanvasDefaultProps = exports.TreeMapCanvasDefaultProps = _extends({}, commonDefaultProps, {
    pixelRatio: global.window && global.window.devicePixelRatio ? global.window.devicePixelRatio : 1
});


//////////////////
// WEBPACK FOOTER
// ./~/nivo/lib/components/charts/treemap/props.js
// module id = 524
// module chunks = 0